import React from 'react';

const sizeClasses = {
  xs: 'text-xs', // 12px
  sm: 'text-sm', // 14px
  md: 'text-md', // 16px
  lg: 'text-lg', // 18px
  xl: 'text-xl', // 20px
  '2xl': 'text-2xl', // 24px
};

const weightClasses = {
  light: 'font-light', // 300
  normal: 'font-normal', // 400
  medium: 'font-medium', // 500
  semibold: 'font-semibold', // 600
  bold: 'font-bold', // 700
};

/**
 * Props pour le composant Text
 * @interface TextProps
 * @extends {React.HTMLAttributes<HTMLSpanElement>}
 */
export type TextProps = React.HTMLAttributes<HTMLSpanElement> & {
  /** Contenu du texte */
  children: React.ReactNode;
  /** Classes CSS supplémentaires */
  className?: string;
  /** Taille du texte (xs: 12px, sm: 14px, md: 16px, lg: 18px, xl: 20px, 2xl: 24px) */
  size?: keyof typeof sizeClasses;
  /** Poids de la police (light: 300, normal: 400, medium: 500, semibold: 600, bold: 700) */
  weight?: keyof typeof weightClasses;
  /** Active la troncature du texte avec des points de suspension */
  truncate?: boolean;
};

/**
 * Composant Text pour afficher du texte avec des styles prédéfinis
 * @param {TextProps} props - Les propriétés du composant
 * @returns {JSX.Element} Un élément span avec le texte stylisé
 */
export const Text = ({
  children,
  className,
  size = 'md',
  weight = 'normal',
  truncate = false,
  ...props
}: TextProps) => {
  return (
    <span
      className={`${sizeClasses[size]} ${weightClasses[weight]} ${truncate ? 'truncate' : ''} ${className || ''} text-neutralText dark:text-neutralText-dark`}
      {...props}
    >
      {children}
    </span>
  );
};
